import React from "react";
import { Avatar, AvatarGroup } from "@mui/material";

// Project color mapping
const projectColors = {
    SG: "#6A0DAD",
    PQ: "#1976d2",
    CB: "#d81b60",
    // Add more project codes as needed
    DEFAULT: "#9e9e9e" // Fallback color
};

const MemberAvatar = ({ items }) => {
    // Function to get initials from name
    const getInitials = (name) => {
        if (!name) return '';
        const names = name.split(' ');
        let initials = names[0].substring(0, 1).toUpperCase();

        if (names.length > 1) {
            initials += names[names.length - 1].substring(0, 1).toUpperCase();
        }

        return initials;
    };

    // Determine what to display for each item
    const getAvatarContent = (item) => {
        if (item.type === 'project') {
            return item.code; // Show project code for project items
        }
        if (item.avatar) {
            return null; // Will show image
        }
        return getInitials(item.name); // Show initials for members without avatar
    };

    // Get background color based on item type
    const getBgColor = (item) => {
        if (item.type === 'project') {
            return projectColors[item.code] || projectColors.DEFAULT;
        }
        return projectColors[item.code] || projectColors.DEFAULT;
    };

    return (
        <AvatarGroup
            max={3}
            sx={{ justifyContent: 'center' }}
            componentsProps={{
                additionalAvatar: {
                    sx: {
                        width: 40,
                        height: 40,
                        fontSize: '13px',
                        bgcolor: projectColors.DEFAULT,
                        position: 'relative',
                        zIndex: '99',
                    }
                }
            }}
        >
            {items.map((item) => (
                <Avatar
                    key={item.id || item.code}
                    src={item.type === 'member' ? item.avatar : null}
                    sx={{
                        width: 40,
                        height: 40,
                        fontSize: '13px',
                        bgcolor: getBgColor(item),
                    }}
                    alt={item.name || item.code}
                >
                    {getAvatarContent(item)}
                </Avatar>
            ))}
        </AvatarGroup>
    );
};

export default MemberAvatar;